<template>
  <div id="registrar-create" class="row">
    <form id="create-registrar-form" class="small-12 medium-5 columns" @submit.prevent="submitForm">
      <label>
        {{ 'Name'|t }}
        <input type="text" v-model="name" required="required" autofocus />
      </label>

      <label>
        {{ 'Organization'|t }}
        <input type="text" v-model="organization" required="required" />
      </label>

      <label>
        {{ 'Street'|t }}
        <input type="text" v-model="street" required="required" />
      </label>

      <label>
        {{ 'City'|t }}
        <input type="text" v-model="city" required="required" />
      </label>

      <label>
        {{ 'Country'|t }}
        <input type="text" v-model="country" required="required" maxlength="2" />
      </label>

      <label>
        {{ 'State'|t }}
        <input type="text" v-model="state" required="required" maxlength="2" />
      </label>

      <label>
        {{ 'Telephone'|t }}
        <input type="text" v-model="telephone" required="required" />
      </label>

      <label>
        {{ 'E-mail'|t }}
        <input type="email" v-model="email" required="required" />
      </label>

      <label>
        {{ 'Fax'|t }}
        <input type="text" v-model="fax" required="required" />
      </label>

      <label>
        {{ 'Credit'|t }}
        <input type="number" v-model="credit" required="required" min="0" />
      </label>

      <input type="submit" name="submit" :value="'Submit'|t" class="medium expanded success button" />

    </form>
  </div>
</template>

<script>
  import api from '@/api';
  import router from '@/routes';

  export default {
    name: 'CreateForm',
    data() {
      return {
        organization: null,
        name: null,
        street: null,
        city: null,
        state: null,
        country: null,
        email: null,
        telephone: null,
        fax: null,
        credit: null,
      }
    },
    methods: {
      submitForm() {
        let request = {
          org: this.organization,
          name: this.name,
          street: this.street,
          city: this.city,
          state: this.state,
          country: this.country,
          email: this.email,
          phone: this.telephone,
          fax: this.fax,
          credit: parseInt(this.credit),
        };

        api.createRegistrar(
          request,
          data => {
            this.$store.commit('messages/addMessage', {
              type: "status",
              message: "Registrar %d has been created.",
              args: [data.id]
            }, {root: true});
            router.push({name: 'registrar.collection'});
          }
        );
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/registrar/CreateForm.vue